import React from "react"
import { NavLink } from "react-router-dom"
import { navbar } from "../../portfolio"

function Navbar() {
  return (
    <div>
      <div className="container-fluid nav_bg">
        <div className="row">
          <div className="col-lg-10 col-md-12 mx-auto ">
            <nav className="navbar sticky-top navbar-expand-lg navbar-dark ">
              <div className="container-fluid">
                <NavLink className="navbar-brand tran_color" to="/">
                  Komal<span className="navbar-sub">Mahto</span>
                </NavLink>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
                    {navbar.navbar_data.map((val, item) => {
                      return (
                        <li className="nav-item">
                          <NavLink
                            activeClassName="menu_active"
                            className="nav-link"
                            exact
                            to={val[0]}
                          >
                            {val[1]}
                          </NavLink>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
